var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SchematicTerminal = function () {
    lib_core.AbstractInstance.call(this);

    this.onInit(this, this.initialize);
};
lib_core.inherit(SchematicTerminal, lib_core.AbstractInstance);
SchematicTerminal.$class = "SchematicTerminal";

module.exports = SchematicTerminal;

SchematicTerminal.prototype.initialize = function () {
    var self = this;

    this.logicTerminal = this.parent().terminalMap.get(this);
    this.parent().terminalMap.onPut(this, function(m, key, element) {
        if(key === self && self.isAlive()) {
            self.logicTerminal = element;
            self.updateLogicTerminal();
        }
    });
    this.parent().terminalMap.onRemove(this, function(m, key) {
        if(key === self && self.isAlive()) {
            self.logicTerminal = null;
            self.updateLogicTerminal();
        }
    });

    this.pos = this.shadow("pos",
        function(){
            var pos = self.description().pos();
            if(self.parent().xflip() === -1) {
                var flipLine = new lib_geometry.Line(new lib_geometry.Coord(0,1), new lib_geometry.Coord(0,0));
                pos = pos.flip(flipLine);
            }
            return pos.rotate(self.parent().angle()).add(self.parent().pos());
        },
        null,
        [this.parent().pos, this.parent().angle, this.parent().xflip, this.description]
    );

    this.angle = this.shadow("angle",
        function(){
            return (self.description().angle() + self.parent().angle()) % 360;
        },
        null,
        [this.parent().angle, this.description]
    );
};

SchematicTerminal.prototype.net = function() {
    return this.parent().parent().schematicTerminalNetMap.get(this);
};

SchematicTerminal.prototype.updateLogicTerminal = function() {
    var net = this.net();
    if(net) {
        net.terminals.remove(this);
    }
};